import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Col,
  Row,
  message,
  Select,
  DatePicker,
  Button,
  InputNumber,
  Space,
} from "antd";
import {
  API_METHODS,
  BLANK_VALUE,
  DEFAULT_DATE_FORMAT,
} from "../../../constants";
import useApi from "../../../hooks/useApi";
import dayjs from "dayjs";
import {
  getBanks,
  getClientConfig,
  getCreditors,
  formatDateToDayJS,
  isEmpty,
  replaceBlankValueToUndefined,
  displayFormattedDate,
} from "../../../generalFunctions";
import TableComponent from "../../common/table/TableComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";

function AddBillwisePayment() {
  const location = useLocation();
  const innerColumns = [
    {
      title: "Bill Number",
      dataIndex: "billNumber",
    },
    {
      title: "Bill Date",
      dataIndex: "billDate",
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Bill Amount",
      dataIndex: "billAmount",
    },
    {
      title: "Balance Amount",
      dataIndex: "balanceAmount",
    },
  ];

  const outerColumns = [
    {
      title: "Bill Number",
      dataIndex: "billNumber",
      width: 150,
    },
    {
      title: "Bill Date",
      dataIndex: "billDate",
      width: 150,
      render: (text) => displayFormattedDate(text),
    },
    {
      title: "Bill Amount",
      dataIndex: "billAmount",
      width: 150,
    },
    {
      title: "Balance Amount",
      dataIndex: "balanceAmount",
      width: 150,
    },
    {
      title: "Payment Amount",
      dataIndex: "paymentAmount",
      render: (text, record) => (
        <Input
          placeholder="Payment Amount"
          defaultValue={
            record.paymentAmount ? record.paymentAmount : record.balanceAmount
          }
          onChange={(e) => paymentAmountChanged(e, record)}
        ></Input>
      ),
      width: 150,
    },
    {
      title: "Deduction Amount",
      dataIndex: "deductionAmount",
      render: (text, record) => (
        <Input
          placeholder="Deduction Amount"
          defaultValue={record.deductionAmount ? record.deductionAmount : 0}
          onChange={(e) => deductionAmountChanged(e, record)}
        ></Input>
      ),
      width: 150,
    },
    {
      title: "Net Amount",
      dataIndex: "netAmount",
      render: (text, record) => (
        <Input
          placeholder="Net Amount"
          value={record.netAmount ? record.netAmount : record.balanceAmount}
          disabled={true}
        ></Input>
      ),
      width: 150,
    },
    {
      title: "Action",
      key: "action",

      render: (text, record) => (
        <Space>
          <Button size="small" onClick={() => deleteRecord(record)}>
            Delete
          </Button>
        </Space>
      ),
    },
  ];
  const { account, voucherType } = getClientConfig();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [form] = Form.useForm();
  const [visible, setVisible] = useState();
  const [innerTableData, setInnerTableData] = useState();
  const [outerTableData, setOuterTableData] = useState();
  const [billData, setBillData] = useState();
  const [inititalVals, setInitialVals] = useState();
  const navigate = useNavigate();
  const [response, request] = useApi(
    "/billwisePayment",
    null,
    API_METHODS.POST
  );
  const [responseData, getRequest] = useApi(
    "/publicationBill/paymentNotDone",
    null,
    API_METHODS.GET
  );
  const [billwisePaymentDataData, getBillwisePaymentData] = useApi(
    "/billwisePayment/",
    null,
    API_METHODS.GET
  );

  const [editResponse, editRequest] = useApi(
    "/billwisePayment",
    null,
    API_METHODS.POST
  );
  const [loadingSaveButton, setLoadingSaveButton] = useState(false);

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    if (location.state && location.state.payment_id) {
      getBillwisePaymentData(
        null,
        API_METHODS.GET,
        `/billwisePayment/${location.state.payment_id}`
      );
    }
  }, [location.state]);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    setBillData(data);
  }, [responseData]);

  useEffect(() => {
    if (response.data) {
      message.success("Billwise Payment added successfully.");
      setLoadingSaveButton(false);
      navigate("/portal/billwisePayment");
    }
  }, [response]);

  useEffect(() => {
    let initialValues =
      billwisePaymentDataData &&
      billwisePaymentDataData.data &&
      billwisePaymentDataData.data[0];
    if (initialValues) {
      initialValues = replaceBlankValueToUndefined(initialValues);
      initialValues.voucherDate = formatDateToDayJS(initialValues.voucherDate);
      if (!isEmpty(initialValues.chequeDate)) {
        initialValues.chequeDate = formatDateToDayJS(initialValues.chequeDate);
      }
      form.setFieldsValue(initialValues);
      let data = [];
      //billData is bills for which payment is not done

      data =
        billData &&
        billData.length > 0 &&
        billData.filter(
          (billData) => billData.creditorId === initialValues.creditorId // to check if creditorId is available in billdate
        );

      setInnerTableData(data);
      setInitialVals(initialValues);
      if (!isEmpty(initialValues.billData)) {
        setOuterTableData(initialValues.billData);
        let keys = [];
        for (let i = 0; i < initialValues.billData.length; i++) {
          keys.push(initialValues.billData[i].publicationBillId);
          //push other thinhgs if reqd
        }
        setSelectedRows(initialValues.billData);
        setSelectedRowKeys(keys);
      }
    } else if (billwisePaymentDataData.error) {
      navigate("/portal/billwisePayment");
    }
  }, [billwisePaymentDataData]);

  useEffect(() => {
    if (editResponse.data) {
      message.success("Billwise payment updated successfully.");
      setLoadingSaveButton(false);
      navigate("/portal/billwisePayment");
    }
  }, [editResponse]);

  const deleteRecord = (record) => {
    //todo
    const selectedBills = outerTableData.filter((bill) => bill !== record);
    let amount = 0;
    let deductionAmount = 0;
    let newSelectedRowKeys = selectedRowKeys;

    const index = newSelectedRowKeys.indexOf(record.publicationBillId);
    if (index > -1) {
      newSelectedRowKeys.splice(index, 1);
    }

    for (let i = 0; i < selectedBills.length; i++) {
      amount =
        amount +
        (selectedBills[i].paymentAmount
          ? selectedBills[i].paymentAmount
          : selectedBills[i].balanceAmount);
      deductionAmount =
        deductionAmount +
        (selectedBills[i].deductionAmount
          ? selectedBills[i].deductionAmount
          : 0);
    }
    let finalAmount = amount - deductionAmount;
    form.setFieldsValue({ amount, deductionAmount, finalAmount });
    setOuterTableData(selectedBills);
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(selectedBills);
  };

  const creditorChanged = (creditorId) => {
    const data = (billData || []).filter((bill) => bill.creditorId === creditorId);
    if (location.state && creditorId === inititalVals.creditorId) {
      //TODO
      if (inititalVals.billData) {
        let keys = [];
        for (let i = 0; i < inititalVals.billData.length; i++) {
          keys.push(inititalVals.billData[i].publicationBillId);
        }
        setOuterTableData(inititalVals.billData);
        setSelectedRows(inititalVals.billData);
        setSelectedRowKeys(keys);
      }
      form.setFieldsValue(inititalVals);
    } else {
      setOuterTableData();
      setSelectedRows([]);
      setSelectedRowKeys([]);
    }
    form.setFieldsValue({
      amount: 0,
      deductionAmount: 0,
      finalAmount: 0,
    });
    setInnerTableData(data);
  };

  const paymentAmountChanged = (e, record) => {
    let amount = 0;
    let deductionAmount = form.getFieldValue("deductionAmount");
    let newOuterTableData = [...outerTableData];
    newOuterTableData.forEach(function (outerTableRecord) {
      if (outerTableRecord.publicationBillId === record.publicationBillId) {
        outerTableRecord.paymentAmount = Number(e.target.value);
        outerTableRecord.netAmount = Number(
          e.target.value -
            (outerTableRecord.deductionAmount
              ? outerTableRecord.deductionAmount
              : 0)
        );
      }
    });
    for (let i = 0; i < newOuterTableData.length; i++) {
      amount =
        amount +
        (newOuterTableData[i].paymentAmount
          ? newOuterTableData[i].paymentAmount
          : newOuterTableData[i].balanceAmount);
    }
    let finalAmount = amount - deductionAmount;
    form.setFieldsValue({
      amount: amount,
      finalAmount: finalAmount,
    });
    setOuterTableData(newOuterTableData);
  };

  const deductionAmountChanged = (e, record) => {
    let deductionAmount = 0;
    let amount = form.getFieldValue("amount");
    let newOuterTableData = [...outerTableData];
    newOuterTableData.forEach(function (outerTableRecord) {
      if (outerTableRecord.publicationBillId === record.publicationBillId) {
        outerTableRecord.deductionAmount = Number(e.target.value);
        outerTableRecord.netAmount = Number(
          (outerTableRecord.paymentAmount
            ? outerTableRecord.paymentAmount
            : outerTableRecord.balanceAmount) - e.target.value
        );
      }
    });
    for (let i = 0; i < newOuterTableData.length; i++) {
      deductionAmount =
        deductionAmount +
        (newOuterTableData[i].deductionAmount
          ? newOuterTableData[i].deductionAmount
          : 0);
    }
    let finalAmount = amount - deductionAmount;
    form.setFieldsValue({
      deductionAmount: deductionAmount,
      finalAmount: finalAmount,
    });
    setOuterTableData(newOuterTableData);
  };

  const finalDeductionAmountChanged = (deductionAmount) => {
    let amount = form.getFieldValue("amount");
    let finalAmount = amount - deductionAmount;
    form.setFieldsValue({ finalAmount });
  };

  const onFinish = () => {
    //todo
    form.validateFields().then((values) => {
      if (!loadingSaveButton) {
        setLoadingSaveButton(true);
        values.voucherDate = formatDateToDayJS(values.voucherDate);
        if (values.chequeDate) {
          values.chequeDate = formatDateToDayJS(values.chequeDate);
        }
        if (outerTableData && outerTableData.length > 0) {
          values.billIds = outerTableData.map((bill) => ({
            id: bill.publicationBillId,
            paymentAmount: bill.paymentAmount
              ? bill.paymentAmount
              : bill.balanceAmount,
            deductionAmount: bill.deductionAmount ? bill.deductionAmount : 0,
            netAmount: bill.netAmount ? bill.netAmount : bill.balanceAmount,
          }));
        }
        if (location && location.state) {
          editRequest(
            values,
            API_METHODS.PUT,
            `/billwisePayment/${location.state.payment_id}`
          );
        } else {
          request(values, API_METHODS.POST);
        }
      }
    });
  };

  const billsSelected = () => {
    let amount = 0;
    let deductionAmount = 0;
    let newSelectedRows = [...selectedRows];
    if (!isEmpty(outerTableData)) {
      var ids = new Set(outerTableData.map((d) => d.publicationBillId));
      newSelectedRows = [
        ...outerTableData,
        ...newSelectedRows.filter((d) => !ids.has(d.publicationBillId)),
      ];
    }
    for (let i = 0; i < newSelectedRows.length; i++) {
      amount =
        amount +
        (newSelectedRows[i].paymentAmount
          ? newSelectedRows[i].paymentAmount
          : newSelectedRows[i].balanceAmount);
      deductionAmount =
        deductionAmount +
        (newSelectedRows[i].deductionAmount
          ? newSelectedRows[i].deductionAmount
          : 0);
    }
    let finalAmount = amount - deductionAmount;
    form.setFieldsValue({
      amount,
      deductionAmount,
      finalAmount,
    });
    setOuterTableData(newSelectedRows);
    setVisible(false);
  };

  const onRowSelectChange = (newSelectedRowKeys, records) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(records);
  };

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    onChange: onRowSelectChange,
  };

  const setModalVisible = () => {
    setVisible(true);
  };

  const cancel = () => {
    setVisible(false);
  };

  const previousButtonClicked = () => {
    let billwise_payment_id = form.getFieldValue("id") - 1;
    getBillwisePaymentData(
      null,
      API_METHODS.GET,
      `/billwisePayment/${billwise_payment_id}`
    );
  };
  const nextButtonClicked = () => {
    let billwise_payment_id = form.getFieldValue("id") + 1;
    getBillwisePaymentData(
      null,
      API_METHODS.GET,
      `/billwisePayment/${billwise_payment_id}`
    );
  };

  return (
    <div>
      <Form
        layout="vertical"
        form={form}
        initialValues={{
          voucherDate: dayjs(),
          amount: 0,
          deductionAmount: 0,
          finalAmount: 0,
        }}
        onFinish={onFinish}
        disabled={location && location.state && location.state.isViewOnly}
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="voucherDate"
              label="Voucher Date"
              rules={[{ required: true, message: "Voucher Date is required." }]}
            >
              <DatePicker format={DEFAULT_DATE_FORMAT} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="voucherTypeId"
              label="Voucher Type"
              rules={[{ required: true, message: "Voucher Type is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {voucherType.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.type}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="bankId" label="Bank">
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {getBanks(account).map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.accountName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="chequeNumber"
              label="Cheque Number"
              rules={[
                {
                  max: 50,
                  message: "Cheque Number should be maximum of 50 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="chequeDate" label="Cheque Date">
              <DatePicker format={DEFAULT_DATE_FORMAT} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="creditorId"
              label="Creditor"
              rules={[{ required: true, message: "Creditor is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                onSelect={creditorChanged}
              >
                {getCreditors(account).map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.accountName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="post"
              label="Name of the post"
              rules={[
                {
                  max: 50,
                  message:
                    "Name of the post should be maximum of 50 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        {form.getFieldValue("creditorId") && innerTableData && (
          <Button type="primary" onClick={setModalVisible}>
            Select Publication Bills
          </Button>
        )}
        {outerTableData && outerTableData.length > 0 && (
          <TableComponent
            rowKey="publicationBillId"
            columns={outerColumns}
            tableData={outerTableData}
            clientSideRender={true}
          />
        )}
        <Modal
          title="Select Publication Bills"
          open={visible}
          onOk={billsSelected}
          onCancel={cancel}
          width={1000}
          okText="Save"
          destroyOnClose={true}
        >
          <TableComponent
            rowKey="publicationBillId"
            columns={innerColumns}
            tableData={innerTableData}
            rowSelection={rowSelection}
            clientSideRender={true}
          />
        </Modal>
        <Row>
          <Col span={8}>
            <Form.Item
              name="narration"
              label="Narration"
              rules={[
                { required: true, message: "Narration is required." },
                {
                  max: 100,
                  message: "Narration should be maximum of 100 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Amount" name="amount">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Deduction Amount" name="deductionAmount">
              <InputNumber onChange={finalDeductionAmountChanged} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Final Amount" name="finalAmount">
              <InputNumber disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                disabled={
                  isEmpty(outerTableData) ||
                  outerTableData.length === 0 ||
                  (location && location.state && location.state.isViewOnly)
                }
                loading={loadingSaveButton}
              >
                Save
              </Button>
            </Form.Item>
          </Col>
          <Col>
            <Button
              type="primary"
              onClick={() => {
                navigate("/portal/billwisePayment");
              }}
              disabled={false}
            >
              {location && location.state && location.state.isViewOnly
                ? "Close"
                : "Cancel"}
            </Button>
          </Col>
        </Row>
      </Form>
      {location && location.state && location.state.isViewOnly && (
        <Row justify="space-between">
          <Button type="primary" onClick={previousButtonClicked}>
            <LeftOutlined />
            Previous
          </Button>
          <Button type="primary" onClick={nextButtonClicked}>
            Next
            <RightOutlined />
          </Button>
        </Row>
      )}
    </div>
  );
}

export default AddBillwisePayment;
